import _objectSpread from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "regenerator-runtime/runtime.js";
/* eslint-disable camelcase */
// 钱包相关接口
import { dateFormat, fomatePoints, toLocaleString } from '@/common/util';
import { isAndroid, isKwaiMe, isSnack } from '@/utils/env';
import axios, { requestRetry } from './axios';
// Trinity
// 20230726 更换url
// 旧path: /pay/account/h5/account_mask_phone
// 新path: /pay/trade/sms/app/account_mask_phone
export var getMaskPhone = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.post('/pay/trade/sms/app/account_mask_phone', {
              headers: {
                'content-type': 'application/x-www-form-urlencoded'
              }
            });
          case 2:
            res = _context.sent;
            return _context.abrupt("return", (res === null || res === void 0 ? void 0 : res.mask_phone_number) || '');
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getMaskPhone() {
    return _ref.apply(this, arguments);
  };
}();
export var getPrePay = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params, axiosConfig) {
    var formData, res;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            formData = new FormData();
            Object.keys(params).forEach(function (key) {
              formData.append(key, params[key]);
            });
            _context2.next = 4;
            return axios.post('/pay/trade/deposit/pre-pay', formData, _objectSpread({
              headers: {
                'content-type': 'application/x-www-form-urlencoded'
              }
            }, axiosConfig));
          case 4:
            res = _context2.sent;
            return _context2.abrupt("return", res);
          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function getPrePay(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
// 获取账户余额
export var getBalanceInfo = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var _ref4,
      _ref4$balanceInfo,
      balanceInfo,
      _ref4$silent,
      silent,
      cash,
      points,
      res,
      _res$data,
      cashBalance,
      pointsBalance,
      iosHide,
      rawPoints,
      _cash,
      _points,
      cashAccount,
      pointsAccount,
      pointsAccountRaw,
      _args3 = arguments;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _ref4 = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {
              balanceInfo: null,
              silent: false
            }, _ref4$balanceInfo = _ref4.balanceInfo, balanceInfo = _ref4$balanceInfo === void 0 ? null : _ref4$balanceInfo, _ref4$silent = _ref4.silent, silent = _ref4$silent === void 0 ? false : _ref4$silent;
            if (!balanceInfo) {
              _context3.next = 5;
              break;
            }
            cash = balanceInfo.cash * 100;
            points = balanceInfo.point;
            return _context3.abrupt("return", {
              cash: cash,
              points: points,
              cashAccount: toLocaleString(cash / 100, isKwaiMe ? 'en-US' : ''),
              pointsAccount: fomatePoints(points)
            });
          case 5:
            _context3.next = 7;
            return requestRetry({
              reqUrl: '/rest/o/wallet/coin/balance',
              reqHead: 'get',
              params: {},
              configParams: {
                silent: silent
              },
              times: 3
            });
          case 7:
            res = _context3.sent;
            if (!(res !== null && res !== void 0 && res.data)) {
              _context3.next = 16;
              break;
            }
            _res$data = res.data, cashBalance = _res$data.cashBalance, pointsBalance = _res$data.pointsBalance, iosHide = _res$data.iosHide, rawPoints = _res$data.rawBalance;
            _cash = cashBalance.balance;
            _points = pointsBalance.balance;
            cashAccount = toLocaleString(_cash / 100, isKwaiMe ? 'en-US' : '');
            pointsAccount = fomatePoints(_points);
            pointsAccountRaw = fomatePoints(rawPoints);
            return _context3.abrupt("return", {
              cash: _cash,
              points: _points,
              rawPoints: rawPoints,
              cashAccount: cashAccount,
              pointsAccount: pointsAccount,
              pointsAccountRaw: pointsAccountRaw,
              // ios 激励上线，钱包兜底开关是否打开
              iosHide: iosHide
            });
          case 16:
            return _context3.abrupt("return", null);
          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function getBalanceInfo() {
    return _ref3.apply(this, arguments);
  };
}();
var signMap = {
  OUT: '-',
  IN: '+'
};
// 数据格式化处理
var formatFlowData = function formatFlowData(data, format, unit) {
  return data.map(function (item) {
    var description = item.description,
      createTime = item.createTime,
      amount = item.amount,
      direction = item.direction,
      status = item.status,
      operationType = item.operationType,
      showExplain = item.showExplain,
      statusDescription = item.statusDescription;
    return {
      description: description,
      createTime: dateFormat(createTime),
      sign: direction in signMap ? signMap[direction] : '',
      amount: format(amount),
      status: status,
      operationType: operationType,
      unit: unit,
      showExplain: showExplain,
      statusDescription: statusDescription
    };
  });
};
// 现金流水
export var updateCashDetails = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(pcursor, cashUnit) {
    var res, _ref6, hasMore, nextCursor, detailData, details;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(pcursor === 'no_more')) {
              _context4.next = 2;
              break;
            }
            return _context4.abrupt("return");
          case 2:
            _context4.next = 4;
            return axios.get('/rest/o/wallet/coin/cashList', {
              params: {
                pcursor: pcursor
              }
            });
          case 4:
            res = _context4.sent;
            if (!((res === null || res === void 0 ? void 0 : res.result) !== 1)) {
              _context4.next = 7;
              break;
            }
            return _context4.abrupt("return");
          case 7:
            _ref6 = (res === null || res === void 0 ? void 0 : res.data) || {}, hasMore = _ref6.hasMore, nextCursor = _ref6.pcursor, detailData = _ref6.data;
            if (!(nextCursor === pcursor)) {
              _context4.next = 10;
              break;
            }
            return _context4.abrupt("return", {
              pcursor: pcursor,
              hasMore: false,
              data: []
            });
          case 10:
            details = formatFlowData(detailData, function (amount) {
              return "".concat(toLocaleString(amount / 100, isKwaiMe ? 'en-US' : ''));
            }, cashUnit);
            return _context4.abrupt("return", {
              hasMore: hasMore,
              pcursor: nextCursor,
              data: details
            });
          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function updateCashDetails(_x3, _x4) {
    return _ref5.apply(this, arguments);
  };
}();
var getFlowType = function getFlowType() {
  if (isSnack) {
    return 'activitySnackPoint';
  }
  return isAndroid ? 'activityPoint' : 'activityPointMix';
};
/**
 * 快点流水请求
 * @param pcursor
 * @returns
 */
export var updatePointDetails = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(pcursor) {
    var res, _ref8, nextCursor, detailData, details;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(pcursor === 'no_more')) {
              _context5.next = 2;
              break;
            }
            return _context5.abrupt("return");
          case 2:
            _context5.next = 4;
            return axios.post('/rest/o/wallet-v2/main/flow', {
              flowType: getFlowType()
            });
          case 4:
            res = _context5.sent;
            if (!((res === null || res === void 0 ? void 0 : res.result) !== 1)) {
              _context5.next = 7;
              break;
            }
            return _context5.abrupt("return");
          case 7:
            _ref8 = (res === null || res === void 0 ? void 0 : res.data) || {}, nextCursor = _ref8.pcursor, detailData = _ref8.records;
            if (!(nextCursor === pcursor)) {
              _context5.next = 10;
              break;
            }
            return _context5.abrupt("return", {
              pcursor: pcursor,
              hasMore: false,
              data: []
            });
          case 10:
            details = (detailData || []).map(function (item) {
              var _item$description;
              return _objectSpread(_objectSpread({}, item), {}, {
                amount: fomatePoints(item.amount),
                createTime: dateFormat(item.createTime),
                sign: item.direction in signMap ? signMap[item.direction] : '',
                description: (_item$description = item.description) !== null && _item$description !== void 0 ? _item$description : item.title || ''
              });
            });
            return _context5.abrupt("return", {
              hasMore: nextCursor !== 'no_more',
              pcursor: nextCursor,
              data: details
            });
          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function updatePointDetails(_x5) {
    return _ref7.apply(this, arguments);
  };
}();
// 首提任务
export var doValidTask = function doValidTask() {
  try {
    var params = 'taskId=44';
    axios.post('/rest/w/promotion/task/doValidTask', params, {
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      },
      showLoading: false
    });
  } catch (error) {
    // 无需关注错误
  }
};